/* eslint-disable sonarjs/no-duplicate-string */
import makeStyles from "@material-ui/core/styles/makeStyles";

const appBarColor = "white";

const useStyles = makeStyles((theme) => ({
  profileButton: {
    borderRadius: 10,
  },
  logo: {
    height: 40,
  },
  profile: {
    textAlign: "center",
  },
  avatar: {
    display: "block",
    width: 28,
    height: 28,
  },
  select: {
    color: theme.palette.secondary.main,
    "&:before": {
      borderColor: appBarColor,
    },
    "&:after": {
      borderColor: theme.palette.secondary.main,
    },
    "&:not(.Mui-disabled):hover::before": {
      borderColor: theme.palette.secondary.main,
    },
  },
  selectInnerWrapper: {
    padding: 6,
    paddingRight: 12,
  },
  buttonsWrapper: {
    display: "flex",
    alignItems: "center",
  },
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 120,
  },
  navButton: {
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
  },
  appBar: {
    height: 50,
    backgroundColor: appBarColor,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  toolbarRight: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexGrow: 2,
    marginLeft: "1em",
  },
  wsSelectWrap: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  wsSelectIcon: {
    color: theme.palette.secondary.dark,
    marginRight: theme.spacing(1),
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  drawerPaper: {
    width: 320,
  },
  drawerContent: {
    width: 320,
    padding: theme.spacing(1, 2),
    display: "flex",
    flexDirection: "column",
  },
  drawerNavigation: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .MuiButton-root": {
      width: "100%",
      marginBottom: theme.spacing(1),
      justifyContent: "flex-start",
    },
    "& .MuiFormControl-root": {
      width: "100%",
      marginBottom: theme.spacing(1),
    },
  },
  drawerProfile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
  drawerProfileButton: {
    borderRadius: 10,
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.grey[100],
    width: "100%",
    justifyContent: "space-between",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.grey[200],
    },
  },
}));

export default useStyles;
